// extracted by mini-css-extract-plugin
export var chevronIcon = "_sp-1";
export var edgeToggle = "_sp-0";